import { useSelector } from "react-redux";

import { AdminLabOrderList, LabOrder } from "pwapi";

import {
  ExternalLabStainsState,
  ExternalLabsState,
  LabStainsState,
} from "../reducers/frontLoaderReducers";
import { appendSendoutIfNeeded } from "../utils/labUtils";

const useLabOrderExternalLabNames = (
  labOrder: LabOrder | AdminLabOrderList
) => {
  const externalLabs = useSelector(
    ({ externalLabs }: { externalLabs: ExternalLabsState }) => externalLabs
  );
  const externalLabStains = useSelector(
    ({ externalLabStains }: { externalLabStains: ExternalLabStainsState }) =>
      externalLabStains
  );
  const labStains = useSelector(
    ({ labStains }: { labStains: LabStainsState }) => labStains
  );

  const labOrderExternalLabNames = [
    ...new Set(
      labOrder.lab_order_items
        ?.map((labOrderItem) => {
          const labStain = labStains[labOrderItem.lab_stain_id || 0];
          const externalLabStain =
            externalLabStains[labStain?.external_lab_stain_id || 0];
          return externalLabs[externalLabStain?.external_lab_id || 0]?.name;
        })
        .filter((s) => !!s)
    ),
  ];

  return labOrderExternalLabNames.map((externalLabName) =>
    appendSendoutIfNeeded(externalLabName)
  );
};

export default useLabOrderExternalLabNames;
